import { DESKTOP_MAX_SIZE } from "@/constants/screen";
import type { ToastType } from "@/contexts/toastContext";
import type { Theme } from "@getgrover/ui";
import styled from "styled-components";

const getTypeColor = (theme: Theme) => {
  return {
    success: theme.colors.status.baseGreen,
    error: theme.colors.status.baseRed,
    message: theme.colors.background.darkerGrey,
  };
};

export const ToastsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: fixed;
  bottom: ${({ theme }) => theme.spacers["6XL"]};
  left: 0;
  right: 0;
  z-index: 9;
  margin: auto;
  max-width: 100%;
  padding: ${({ theme }) => `0 ${theme.spacers.L}`};

  @media (${({ theme }) => theme.screens.tablet}) {
    width: calc(${DESKTOP_MAX_SIZE} - 4px);
  }
`;

export const ToastWrapper = styled.div<{
  $height: number | undefined;
  $isVisible: boolean;
}>`
  width: 100%;
  height: ${({ $isVisible, $height }) => ($isVisible ? `${$height}px` : "0px")};
  transition: height 0.3s ease;
`;

export const ToastContent = styled.button<{
  $isLink: boolean;
  $isExiting: boolean;
  $isVisible: boolean;
}>`
  display: flex;
  align-items: center;
  border: none;
  background-color: ${({ theme }) => theme.colors.background.white};
  box-shadow: 0 7px 15px 0 #00000021;
  border-radius: ${({ theme }) => theme.borderRadius.S};
  padding: ${({ theme }) => theme.spacers.L};
  width: 100%;
  cursor: ${({ $isLink }) => ($isLink ? "pointer" : "default")};
  transform: ${({ $isExiting, $isVisible }) =>
    $isExiting
      ? "translateY(0) scale(0.9)"
      : $isVisible
        ? "translateY(0)"
        : "translateY(-40px)"};
  opacity: ${({ $isExiting, $isVisible }) => ($isExiting || !$isVisible ? 0 : 1)};
  transition: transform 0.3s ease, opacity 0.3s ease;
`;

export const IconContainer = styled.div<{
  $type: ToastType;
}>`
  display: flex;
  align-items: flex-start;
  height: 100%;
  margin-right: ${({ theme }) => theme.spacers["2M"]};
  color: ${({ $type, theme }) => getTypeColor(theme)[$type]};
`;

export const ContentContainer = styled.div`
  display: inline-block;
  flex: 1;
  text-align: left;
`;

export const ToastTitle = styled.span`
  ${({ theme }) => theme.typography.SmallParagraphBold};
  color: ${({ theme }) => theme.colors.text.darkerGrey};
  margin-right: ${({ theme }) => theme.spacers.S};
`;

export const ToastMessage = styled.span`
  ${({ theme }) => theme.typography.SmallParagraph};
  color: ${({ theme }) => theme.colors.text.darkGrey};
`;
